// extracted by mini-css-extract-plugin
export default {"floatingWhatsapp":"WhatsAppSupport_floatingWhatsapp__O5etj","whatsappIcon":"WhatsAppSupport_whatsappIcon__YVAIB"};